__turbopack_context__.v({
  "notifications-dropdown": "notifications-dropdown-module-scss-module__JczwdW__notifications-dropdown",
  "notifications-dropdown__card": "notifications-dropdown-module-scss-module__JczwdW__notifications-dropdown__card",
  "notifications-dropdown__content": "notifications-dropdown-module-scss-module__JczwdW__notifications-dropdown__content",
  "notifications-dropdown__header": "notifications-dropdown-module-scss-module__JczwdW__notifications-dropdown__header",
  "notifications-dropdown__header-actions": "notifications-dropdown-module-scss-module__JczwdW__notifications-dropdown__header-actions",
  "notifications-dropdown__panel": "notifications-dropdown-module-scss-module__JczwdW__notifications-dropdown__panel",
  "slide-in": "notifications-dropdown-module-scss-module__JczwdW__slide-in",
  "slide-out": "notifications-dropdown-module-scss-module__JczwdW__slide-out",
});
